{
  "site_forbidden": "Sorry, you don't have permission to access this site.",
  "site_not_found": "Sorry, we couldn't find the site you're looking for. Please try again.",
  "rate_limited": {
    "title": "Too many attempts",
    "message": "Please wait a few minutes before trying again."
  }
}
